import React, { useContext, useState, Fragment } from "react";
import { RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";
import useAlert from "~/common/hooks/useAlert";

const InquirySelect = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(ApplyContext);
	const [options, setOptions] = useState(card.option);
	const [showWarningAlert, Warning] = useAlert();

	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	const handleOptionAddFields = (event) => {
		event.preventDefault();
		const values = options;
		values.push("");
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	const handleOptionRemoveFields = (event, index) => {
		event.preventDefault();
		const values = options;
		values.splice(index, 1);
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	const handleOptionInputChange = (index, event) => {
		const removeEmptyElement = options.filter((item) => item !== "");
		removeEmptyElement.includes(event.target.value) && showWarningAlert();
		const values = options;
		values[index] = event.target.value;
		setOptions(values);
		setListByTarget({ ...card, option: values });
	};

	return (
		<div className="c__form horiz inquiry-type-choice">
			<div className="f__group export-label ">
				<div className="f__control  ">
					<input
						name="inquiryChoice"
						className="c__input f__item"
						placeholder={t(
							"pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.question"
						)}
						type="text"
						value={card.title}
						onChange={handleChange}
						readOnly={card.disabled}
					/>
				</div>
			</div>
			{card.disabled ? (
				<div className="export-input-preview">{`기업이 직접 답변 ${
					card.type === "SELECT" ? "단일" : "다중"
				} 선택`}</div>
			) : (
				<>
					{options.map((o, index) => (
						<Fragment key={index}>
							<div className="f__group">
								<div className="f__control-wrap">
									<input
										placeholder={`${t(
											"pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.option1"
										)}${index + 1}`}
										className="c__input export-input"
										id={"optionName" + index}
										name="optionName"
										value={o}
										onChange={(event) => handleOptionInputChange(index, event)}
									/>
									<button
										type="button"
										className="btn-round-delete"
										onClick={(event) => handleOptionRemoveFields(event, index)}
									>
										<RoundMinusIcon />
									</button>
								</div>
							</div>
						</Fragment>
					))}
					<button
						type="button"
						className="dashed-btn plus-btn"
						onClick={(event) => handleOptionAddFields(event)}
					>
						<PlusIcon />
						{t("pages.round.RoundReg.Inquiry.content.cardType.InquiryChoice.addOption")}
					</button>
				</>
			)}
			<Warning
				type="info"
				message={"중복 사항 확인"}
				subMessage={"동일한 옵션을 입력했습니다."}
				confirm={t("common.commonWord.button.check")}
			/>
		</div>
	);
};

export default InquirySelect;
